export const lightTheme = {
  body: '#FAFAFA',
  text: '#363537',
  toggleBorder: '#FFF',
  border: 'rgba(128, 128, 128, 0.25)',
  gradient: 'linear-gradient(#39598A, #79D7ED)',
  boxShadowDefault: '0 16px 64px -16px rgba(46,55,77, 0.1)',
  boxShadowHover: '0 16px 64px -16px rgba(46,55,77, 0.3)',
};

export const darkTheme = {
  body: '#363537',
  text: '#FAFAFA',
  toggleBorder: '#6B8096',
  border: 'rgba(128, 128, 128, 0.5)',
  gradient: 'linear-gradient(#091236, #1E215D)',
  boxShadowDefault: '0 16px 64px -16px rgba(255, 255, 255, 0.1)',
  boxShadowHover: '0 16px 64px -16px rgba(255, 255, 255, 0.2)',
};
